import { render } from "./SpiceLand.vue?vue&type=template&id=a7bc3dc4"
import script from "./SpiceLand.vue?vue&type=script&lang=js"
export * from "./SpiceLand.vue?vue&type=script&lang=js"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__